import HeroContent from './HeroContent';

export default HeroContent;
